import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RestFilledSvg from "@ant-design/icons-svg/es/asn/RestFilled";
import AntdIcon from "../components/AntdIcon";
var RestFilled = function RestFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RestFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RestFilled.displayName = 'RestFilled';
}
export default /*#__PURE__*/React.forwardRef(RestFilled);